import { Component } from 'react'
import { observer, inject } from 'mobx-react'
import _ from 'lodash'
import HoldingRow from './HoldingRow'

import { Spacer } from '../../../components'
import { SplitBarChartHeader, SplitBarChartRisk, SplitBarChartLegend } from '../../shared'
import { Page, PageHeader } from '../elements'
import { ContentMainHeaderChart } from '../elements/styled'

const IndexToSVGMap = {
  0: 'Cash',
  1: 'Bonds',
  2: 'Stock',
  3: 'Misc',
}
class HoldingChartPage extends Component {
  renderRows(data, svg) {
    const sortedData = _.orderBy(data, obj => [(obj?.name || '').toLowerCase()], ['asc'])

    return sortedData
      .filter(item => item.newValue !== null || item.oldValue !== null)
      .map((item, i) => {
        return (
          <HoldingRow
            key={item.name}
            title={item.name}
            i={i}
            svg={svg}
            oldValue={item.oldValue}
            newValue={item.newValue}
          />
        )
      })
  }

  UNSAFE_componentWillMount() {
    this.props.guide.guidePages.pages.addPage({ name: 'holdingChart' })
  }

  render() {
    const { store, guide } = this.props
    const { displayName } = store.person
    const {
      active,
      employerAccount,
      config,
      institutionalHoldingData,
      config: { isRetail },
    } = store
    const { name: clientInstitutionName } = active
    const page = guide.guidePages.pages.findByName('holdingChart')

    const accountName = () => {
      let name = ''
      if (isRetail && employerAccount.length > 0) {
        name = employerAccount.filter(acct => acct.participantId === store.person.id)[0]?.name || ''
      } else {
        name = employerAccount[0]?.name
      }

      switch (config.templateId) {
        case 1:
        case 2:
          return `${displayName}'s ${clientInstitutionName} account`

        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
        case 19:
          return `${displayName}'s retirement plan account (${name})`
        default:
          return `${displayName}'s retirement plan account with ${config.template.sponsorName}`
      }
    }

    // `acceptedCase` is a declared maybeNull, and this page is the old-vs-new
    // investment mix, so drop it rather than chart a missing recommendation.
    if (store.acceptedCase == null) return null

    // `baseCase` is a declared maybeNull, and the old side of this old-vs-new chart is
    // all that reads it -- with no base case there is no prior mix to plot, so hide the
    // old column the way a zero-balance account already does and keep the new one.
    const { riskLevelTextShort: oldRiskText, riskScaleIndex } = store.baseCase ?? {}
    const { riskLevelTextShort: newRiskText, riskScaleIndex: riskScaleIndexNew } =
      store.acceptedCase

    return Boolean(active) && Boolean(institutionalHoldingData) ? (
      <Page header={<PageHeader text='Your Plan' />} page={page}>
        <ContentMainHeaderChart>Investment mix for: {accountName()}</ContentMainHeaderChart>
        <Spacer space='6px' />
        <SplitBarChartLegend paddingLeft={45} />
        <Spacer space='4px' />
        <SplitBarChartHeader />
        <SplitBarChartRisk
          hideOld={store.baseCase == null || active.balance === 0}
          oldRiskText={oldRiskText}
          newRiskText={newRiskText}
          rangeIndexOld={riskScaleIndex}
          rangeIndexNew={riskScaleIndexNew}
        />

        {institutionalHoldingData.map((mix, inx) => this.renderRows(mix, IndexToSVGMap[inx]))}
      </Page>
    ) : null
  }
}

export default inject('store', 'guide')(observer(HoldingChartPage))
